<template>
  <div class="scrollbar1">
    <div
      class="chart"
      ref="barchartdiv"
      v-if="monthlyCommision.length > 0"
    ></div>
    <div class="chart" ref="chartdiv" v-else>
      <div class="noChartData whiteBG">
        <img
          src="../../../../static/fxView/images/line-chart.svg"
          width="100px"
          alt="Icon"
        />
        <p>No Data</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

import moment from "moment";
import { fxViewMixins } from "@/plugins/fxView";
export default {
  name: "REFERAL-LINK-ANALYSIS",
  mixins: [fxViewMixins],
  data() {
    return {
      pageTitle: this.$options.name,
      pageLimit: 15,
      page: 1,
      search: "",
      chart_data: [],
    };
  },
  props: ["monthlyCommision"],
  methods: {
    intializeBarChart() {
      am4core.addLicense("ch-custom-attribution");
      let chart = am4core.create(this.$refs.barchartdiv, am4charts.XYChart);
      chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
      chart.data = this.chart_data;

      let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "date";
      categoryAxis.renderer.grid.template.strokeOpacity = 0;
      categoryAxis.renderer.minGridDistance = 10;
      categoryAxis.renderer.labels.template.dx = -20;
      categoryAxis.renderer.minWidth = 120;
      categoryAxis.renderer.tooltip.dx = -20;

      let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.fillOpacity = 0.3;
      valueAxis.renderer.grid.template.strokeOpacity = 0;
      valueAxis.min = 0;
      valueAxis.cursorTooltipEnabled = false;
      valueAxis.renderer.baseGrid.strokeOpacity = 0;
      valueAxis.renderer.labels.template.dy = 30;

      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueX = "totalCommission";
      series.dataFields.categoryY = "date";
      series.tooltipText = "{valueX.totalCommission}";
      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.dy = -15;
      series.columnsContainer.zIndex = 100;

      let columnTemplate = series.columns.template;
      columnTemplate.height = am4core.percent(50);
      columnTemplate.maxHeight = 50;
      columnTemplate.column.cornerRadius(0, 5, 0, 5);
      columnTemplate.strokeOpacity = 0;
      series.tooltipText = "{valueX.value}";
      chart.cursor = new am4charts.XYCursor();

      series.heatRules.push({
        target: columnTemplate,
        property: "fill",
        dataField: "valueX",
        min: am4core.color("#e5dc36"),
        max: am4core.color("#5faa46"),
      });
      series.mainContainer.mask = undefined;
    },
    barChartData() {
      this.chart_data = this.monthlyCommision.slice(0, 5);
      this.intializeBarChart();
    },
  },
  created() {
    const _that = this;
    setTimeout(function () {
      _that.barChartData();
    }, 1000);
    this.setData(this.pageTitle);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart {
  height: 280px;
}
</style>



// WEBPACK FOOTER //
// src/components/fxView/shared/bar_chart.vue